/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BasketDiscountUpdateRequest } from '../../models/basket-discount-update-request';
import { DiscountUpdateRequest } from '../../models/discount-update-request';
import { QuantityDiscountUpdateRequest } from '../../models/quantity-discount-update-request';
import { SegmentDiscountUpdateRequest } from '../../models/segment-discount-update-request';

export interface UpdateDiscount$Params {
  discountId: string;
      body: (DiscountUpdateRequest | BasketDiscountUpdateRequest | QuantityDiscountUpdateRequest | SegmentDiscountUpdateRequest)
}

export function updateDiscount(http: HttpClient, rootUrl: string, params: UpdateDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateDiscount.PATH, 'put');
  if (params) {
    rb.path('discountId', params.discountId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateDiscount.PATH = '/discounts/{discountId}';
